import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../common/themes/themes';
import { useAppSelector } from '../../infra/hooks';
import { useTranslation } from 'react-i18next';
import ActionRequiredMenusController from '../../domain/actionRequired/ActionRequiredMenus/ActionRequiredMenusController';
import ActionRequiredViewerController from '../../domain/actionRequired/ActionRequiredViewer/ActionRequiredViewerController';

const ActionRequiredPresenter = () => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const { i18n, t } = useTranslation();

  return (
    <Grid
      container
      style={{
        height: '100%',
        marginTop: '4em',
        width: '100vw',
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: isHRView ? '-3em' : '',
          marginLeft: '-1em',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#F5F5FA',
            width: '100%',
            height: 'auto',

            marginRight: i18n.language == 'ar' ? '6em' : '',
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{
                display: 'flex',
                padding: '20px',
                flexWrap: 'wrap',
              }}
            >
              <Box>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      width: '92vw',
                      marginTop: '1.75em',
                      padding: '1em',
                    }}
                  >
                    <Box
                      style={{
                        width: 'auto',
                        height: 'auto',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '10px',
                        opacity: '1',
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '1em',
                        paddingBottom: '1em',
                        paddingLeft: '1em',
                        paddingRight: '1em',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.header,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {t('Action Required')}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'nowrap',
                  }}
                  spacing={2}
                >
                  <Grid item xs={3} sm={3} md={3} lg={3}>
                    <ActionRequiredMenusController />
                  </Grid>
                  <Grid item xs={9} sm={9} md={9} lg={9}>
                    <ActionRequiredViewerController />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ActionRequiredPresenter;
